// src/components/Link.js (DEINE LinkElement-Komponente)
import React from 'react';
import { Link as RouterLink } from 'react-router-dom'; // Wichtig: Alias für Link

const LinkElement = ({ Name, Link: url, TextColorHexCode }) => {
  // Stellen Sie sicher, dass Name und URL vorhanden sind, bevor gerendert wird
  if (!Name || !url) {
    console.warn("LinkElement: 'Name' oder 'Link' Prop fehlt für einen Link.");
    return null; // Nichts rendern, wenn essenzielle Daten fehlen
  }

  // Bestimmen, ob es sich um einen internen Link handelt
  // Ein interner Link für diese Anwendung beginnt mit "/Interact/" oder ist einfach "/"
  const isInternalLink = url.startsWith('/');
  const targetPath = `/Interact${url}`;
  // Standard-Styles für die Links
  const linkStyle = {
    color: TextColorHexCode || '#0d6efd', // Standard-Bootstrap-Primärfarbe als Fallback
  };

  if (isInternalLink) {
    // Für interne Links verwenden wir die RouterLink-Komponente
    // Wir übergeben den vollen Pfad, da dein Router diesen bereits direkt handhaben sollte
    // (z.B. /Interact/legal-notice)
    return (
      <RouterLink
        to={targetPath} // Den URL-Pfad direkt an die 'to'-Prop übergeben
        className="text-decoration-none"
        style={linkStyle}
        onMouseEnter={e => e.currentTarget.style.textDecoration = 'underline'}
        onMouseLeave={e => e.currentTarget.style.textDecoration = 'none'}
      >
        {Name}
      </RouterLink>
    );
  } else {
    // Für externe Links verwenden wir einen normalen <a>-Tag
    return (
      <a
        href={url}
        className="text-decoration-none"
        style={linkStyle}
        onMouseEnter={e => e.currentTarget.style.textDecoration = 'underline'}
        onMouseLeave={e => e.currentTarget.style.textDecoration = 'none'}
        target="_blank" // Externe Links in einem neuen Tab öffnen
        rel="noopener noreferrer" // Sicherheit für externe Links
      >
        {Name}
      </a>
    );
  }
};

export default LinkElement;